import { isAnyOf } from '@reduxjs/toolkit';
import { startAppListening } from '@app/listenerMiddleware';
import { enhancedApi as api } from '@services/df/auth';

startAppListening({
    matcher: isAnyOf(
        api.endpoints.auth.matchFulfilled,
        api.endpoints.obtainAnonymousAuthTokenCreate.matchFulfilled,
        api.endpoints.obtainAuthTokenCreate.matchFulfilled,
        api.endpoints.postV22FaVerify.matchFulfilled,
        api.endpoints.signupCreate.matchFulfilled,
    ),
    effect: async (action, { getState, extra: { AuthService } }) => {
        const state = getState();
        const { token } = state.auth;

        AuthService.init('').setHeaders(token!);
    },
});
